import { render } from "./ZenOne.vue?vue&type=template&id=88ab2c58"
import script from "./ZenOne.vue?vue&type=script&lang=js"
export * from "./ZenOne.vue?vue&type=script&lang=js"

import "./ZenOne.vue?vue&type=style&index=0&id=88ab2c58&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__